import React from 'react'
import { Button, Icon } from 'react-bulma-components'
import { Link } from 'react-router-dom'
import { ViewListIcon } from '@heroicons/react/solid'
import { dateInputToDateValue, formatCompleteDate } from '../../utils/date'
import { useWorkPeriodsQuery } from '../../queries/work-periods'
import { FiltersResourcesEnum } from '../../store/filters'
import useFilters from '../../hooks/filters'
import { WorkPeriodsFilters } from '../../components/work-periods/filters'
import { endOfDay, startOfDay } from 'date-fns'
import ListPageLayout from '../../components/layout/list-page-layout'
import WorkPeriodList from 'src/components/work-periods/list'

const WorkPeriodsList: React.FunctionComponent = () => {
  const { filters } = useFilters(FiltersResourcesEnum.workPeriods)
  console.log(filters.start)
  const query = useWorkPeriodsQuery({
    ...filters,
    start: startOfDay(dateInputToDateValue(filters.start)),
    end: endOfDay(dateInputToDateValue(filters.start)),
    summary: true,
  })

  const action = (
    <Button renderAs={Link} to="/missions/" outlined color="primary" size="small">
      <Icon>
        <ViewListIcon />
      </Icon>
      <span>Liste des Missions</span>
    </Button>
  )

  return (
    <ListPageLayout
      title="Liste des Journées de Travail"
      subtitle={formatCompleteDate(filters.start)}
      action={action}
      filters={<WorkPeriodsFilters />}
    >
      <WorkPeriodList workPeriods={query.data ?? []} />
    </ListPageLayout>
  )
}

export default WorkPeriodsList
